import { render, staticRenderFns } from "./RefundNote.vue?vue&type=template&id=67ec539c&scoped=true&"
import script from "./RefundNote.vue?vue&type=script&lang=js&"
export * from "./RefundNote.vue?vue&type=script&lang=js&"
import style0 from "./RefundNote.vue?vue&type=style&index=0&id=67ec539c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ec539c",
  null
  
)

export default component.exports